import axios from "axios";

export default function getCompanyProductCustomFields() {
  return new Promise((resolve, reject) => {
    axios
      .get("/serialnumber/api/v1/product/get-custom-fields")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
